export default __webpack_public_path__ + "static/media/SGI RGB logo 300dpi.e7da7b3c.png";